// extracted by mini-css-extract-plugin
export default {"root":"WcJ6bbRApLq8_DZzpBFm"};